<template>
    <div ref="routesContainer">
        <div class="bg-white p-5 mb-3 rounded">
            <div
                class="d-lg-flex align-items-center justify-content-between mb-4 gap-2"
            >
                <h3>
                    <strong style="color: #1a0054"
                        >Rutas predeterminadas</strong
                    >
                </h3>
            </div>

            <StepOneListRoutesDefault
                v-if="step === STEPS.LIST"
                :categoryroutes="categoryroutes"
                :categorysearch="categorysearch"
                :url_suggest_routes="url_suggest_routes"
                :info="info"
                @changeStep="handleStepChange"
            />
            <StepTwoAddUsers
                v-if="step === STEPS.ADD_USERS"
                :url_get_students="url_get_students"
                :url_get_companies="url_get_companies"
                :info="info"
                :empresa_elegida="selectedCompany"
                @changeStep="handleStepChange"
            />
            <StepThreeConfirmation
                v-if="step === STEPS.CONFIRMATION"
                :info="info"
                :url_get="url_get"
                :empresa_elegida="selectedCompany"
                :url_redirect="url_redirect"
                @changeStep="handleStepChange"
            />
        </div>
    </div>
</template>

<script>
import StepOneListRoutesDefault from "./defaultRoutes/DefaultRoutesList.vue";
import StepTwoAddUsers from "./defaultRoutes/DefaultRoutesAddUsers.vue";
import StepThreeConfirmation from "./defaultRoutes/DefaultRoutesConfirmation.vue";

const STEPS = {
    LIST: 1,
    ADD_USERS: 2,
    CONFIRMATION: 3,
};

const createEmptyInfo = () => ({
    ruta: {},
    users: [],
});

export default {
    name: "DefaultRoutes",
    components: {
        StepOneListRoutesDefault,
        StepTwoAddUsers,
        StepThreeConfirmation,
    },
    props: {
        categoryroutes: { type: String, default: "" },
        categorysearch: { type: String, default: "" },
        url_get: { type: String, required: true },
        url_suggest_routes: { type: String, required: true },
        url_get_students: { type: String, required: true },
        url_get_companies: { type: String, required: true },
        url_redirect: { type: String, required: true },
    },
    data() {
        return {
            STEPS,
            step: STEPS.LIST,
            info: createEmptyInfo(),
            selectedCompany: "",
        };
    },
    methods: {
        handleStepChange(data) {
            this.scrollToTop();

            // Si data es un array (formato antiguo), convertir a objeto
            const stepData = Array.isArray(data)
                ? {
                      step: data[0],
                      route: data[1],
                      users: data[2],
                      company: data[3],
                  }
                : data;

            const { step, route, users, company } = stepData;

            this.step = step;

            if (route !== undefined) {
                this.info.ruta = route;
            }

            if (users !== undefined) {
                this.info.users = users;
            }

            if (company !== undefined) {
                this.selectedCompany = company;
            }
        },
        scrollToTop() {
            this.$refs.routesContainer?.scrollIntoView({ behavior: "smooth" });
        },
    },
};
</script>
